import type { PropsWithChildren, JSX } from 'react';

type ClickableAreaProps = {
  logo: JSX.Element;
  onClick: () => void;
};

export const ClickableArea = ({ children, logo, onClick }: PropsWithChildren<ClickableAreaProps>) => {
  return (
    <button type="button" className="flex items-center w-full px-4 border border-l-0 border-r-0 border-solid bg-contrast border-background h-14" onClick={onClick}>
      <div className="mr-4">{logo}</div>
      <div className="text-sm">{children}</div>
    </button>
  );
};
